<fuse-main *ngIf="!isMobile" [@.disabled]="animationsDisabled"> </fuse-main>
<div *ngIf="isMobile">  
    <style>
      html, body {
        height: 100%;
        margin: 0;
        padding: 0;
      }
      
      .container {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
      
      header {
        background-color: #3f3f3f;
        color: white;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        position: sticky;
        top: 0;
      }
      
      .scrollable-container {
        flex-grow: 1;
        overflow-y: auto;
        padding: 20px;
      }
      
      .button {
        padding: 10px 20px;
        border: none;
        border-radius: 4px;
        background-color: #4CAF50;
        color: white;
        text-align: center;
        text-decoration: none;
      }
      
      .back-button {
        margin-right: 10px;
      }

      .logo {
          background-color: transparent;
          color:rgba(255, 255, 255, 0.87);
          display: flex;
          align-items: center;

          .logo-icon {
              width: 38px;
              height: 38px;              
              background-color: transparent;
              color:rgba(255, 255, 255, 0.87);
          }

          .logo-text {
              margin-left: 8px;
              font-size: 20px;
              font-weight: 300;
              letter-spacing: 0.4px;
              color:rgba(255, 255, 255, 0.87);
              background-color: transparent;
          }
      }

    </style>
  
    <div class="container">
      <header>
        <div class="logo">
          <img src="assets/images/logos/logo.png" alt="SHSU Logo" class="logo-icon">
          <span id="navbarAppName" class="logo-text">InCase365</span>
        </div>
        <button id="btnLogout" (click)="logOut()" title="Logout">          
          <mat-icon style="color:white">exit_to_app</mat-icon>
          <span style="color:white; display: flex">Logout</span>
        </button>
      </header>
      <router-outlet></router-outlet>
    </div>
</div>
<div *ngIf="isShowingRouteLoadIndicator" class="router-load-indicator">
  Loading...
</div>
